import { render, staticRenderFns } from "./PieceProduct.vue?vue&type=template&id=41e147fa&scoped=true&"
import script from "./PieceProduct.vue?vue&type=script&lang=js&"
export * from "./PieceProduct.vue?vue&type=script&lang=js&"
import style0 from "./PieceProduct.vue?vue&type=style&index=0&id=41e147fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e147fa",
  null
  
)

export default component.exports